"use client";

import ErrorComponent from "@/components/errorBoundary/ErrorComponent";

export default function Error() {
  return <ErrorComponent />;
}

